import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import Header from "../../../layout/header";
import BottomMenu from "../../../layout/bottomMenu";
import DashboardMenu from "../../../layout/dashboardMenu";
import {fseDetailsPJP} from "../../../../service/FasttagToll/action";


const FSEs = ({
                     match,
                  fseDetailsPJP,
                  PJPReviewDetails= [],
                     tollById,
                     tollView= []
                 }) => {

    const [isLoading, setIsLoading] = useState(false)

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await fseDetailsPJP(match?.params?.id)
            await tollById(match?.params?.account_id)
            setIsLoading(false)
        })()
    }, [])



    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"FSEs Details"}
                        />
                        {/*BODY*/}
                        <div className="container-fluid common-bg">
                            <div className="row">
                                <div className="col-md-12">
                                    <div
                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                        <h1 className="h3 mb-0 text-black-100"><b>Toll Details</b></h1>
                                    </div>
                                    <div className="card-body bg-white">
                                        <div className="user">
                                            <div className="form-group row">
                                                <div className="col-md-6 float-field ">
                                                    <input type="number"
                                                           className="form-control form-control-user"
                                                           placeholder=" "
                                                           value={tollView?.data?.fast_tag_toll_no}
                                                    />
                                                    <label className="large-label float-lb">
                                                        Plaza Id
                                                    </label>
                                                </div>
                                                <div className="col-md-6 float-field ">
                                                    <input type="text"
                                                           className="form-control form-control-user"
                                                           placeholder=" "
                                                           value={tollView?.data?.client_name}
                                                    />
                                                    <label className="large-label float-lb">
                                                        Plaza Name
                                                    </label>
                                                </div>
                                                <div className="col-md-6 float-field ">
                                                    <input type="text"
                                                           className="form-control form-control-user"
                                                           placeholder=" "
                                                           value={tollView?.data?.city_name}
                                                    />
                                                    <label className="large-label float-lb">
                                                        City
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {PJPReviewDetails?.data && PJPReviewDetails?.data.length > 0 &&
                                <>
                                    {PJPReviewDetails?.data.map((val, i) => {
                                        return (
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div
                                                        className="d-sm-flex align-items-center justify-content-between com-sub-heading" style={{backgroundColor:'bisque'}}>
                                                        <h1 className="h3 mb-0 text-black-100"><b>FSE Details {i+1}</b></h1>
                                                    </div>
                                                    <div className="card-body bg-white">
                                                        <div className="user">
                                                            <div className="form-group row">
                                                                <div className="col-md-6 float-field " key={i}>
                                                                    <input type="text"
                                                                           className="form-control form-control-user"
                                                                           placeholder=" "
                                                                           required={true}
                                                                           value={val?.phone_no}
                                                                    />
                                                                    <label className="large-label float-lb">
                                                                        Competitor Name
                                                                    </label>
                                                                </div>

                                                                <div className="col-md-6 float-field ">
                                                                    <img alt={"selfie"} src={val?.selfie}/>
                                                                    <label className="large-label float-lb">
                                                                        Monthly tags sold
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        )
                                    })}

                                </>
                            }
                        </div>
                    </div>
                </div>
                <BottomMenu/>
            </div>
        </>
    )
}

export default FSEs